<!-- FifthSection -->
<template>
    <div class="fifthSectionContainer">
        <h1 class="title">
            <span class="block">Pourquoi</span>Prexange est la solution ?
        </h1>
        <img class="image" :src="image" alt="image">
        <div class="details">
            <div class="leftbox">
                <span class="title">Gain de productivité</span>
                <div class="description">
                    <p>
                        <icon class="icon" icon="ph:check-fat-fill" height="15" />
                        Collectez les documents de votre client, faites l’analyse de sa demande, rédigez la synthèse de financement (« carcasse ») <br> puis soumettez le tout pour publication sur Prexange .
                    </p>
                    <p>
                        <icon class="icon" icon="ph:check-fat-fill" height="15" />
                        Renseignez un seul outil alimentant les différentes applications bancaires.
                    </p>
                    <p>
                        <icon class="icon" icon="ph:check-fat-fill" height="15" />
                        Montez une seule fois votre dossier et obtenez toutes les meilleures propositions des banques grâce à une multi présentation<br> en simultané .
                    </p>
                </div>
            </div>
            <div class="rightbox">
                <span class="title">Gain financier</span>
                <div class="description">
                <p>
                    <icon class="icon" icon="ph:check-fat-fill" height="15" />
                    Apportez les meilleures propositions à vos clients en un temps record vous permettra d’améliorer votre « image de marque » et vous facilitera la conquête de nouveaux clients.
                </p>
                <p>
                    <icon class="icon" icon="ph:check-fat-fill" height="15" />
                    Consacrez le temps gagné à développer votre activité .
                </p>
            </div>
            </div>
        </div>
    </div>
</template>
<script>

import image from '@/assets/images/image35-5sc.png';
import { Icon } from '@iconify/vue2/dist/iconify.js';

export default {
    name: 'FifthSection',
    components: {
        Icon,
    },
    data() {
        return {
            image: image,
            isSidebarOpen: false,
        };
    },
};
</script>


<style lang="scss">
@import './FifthSection.scss'
</style>